<template>
  <div style="padding:20px">
    <h3>OSS STS直传（分片上传，大文件自动分片）</h3>
    <input type="file" ref="fileRef" @change="handleFileChange" />
    <div v-if="percent > 0">上传进度：{{ percent }}%</div>
    <div v-if="fileUrl" style="margin-top:10px">
      上传成功：<a :href="fileUrl" target="_blank">{{ fileUrl }}</a>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import OSS from 'ali-oss'

const fileRef = ref(null)
const percent = ref(0)
const fileUrl = ref('')

// 1. 请求后端拿STS临时凭证
async function getStsInfo() {
  // 改成你后端地址，本地开发就是 /upload/sts，跨域的话配置后端cors
  const res = await fetch(process.env.VUE_APP_BASE_URL + '/upload/sts')
  return await res.json()
}

async function handleFileChange(e) {
  const file = e.target.files[0]
  if (!file) return
  percent.value = 0
  fileUrl.value = ''

  // 获取临时密钥
  const sts = await getStsInfo()
  console.log("拿到STS凭证", sts)

  // 初始化OSS客户端
  const client = new OSS({
    region: 'cn-shanghai',
    endpoint: 'oss-cn-shanghai.aliyuncs.com',
    accessKeyId: sts.accessKeyId,
    accessKeySecret: sts.accessKeySecret,
    stsToken: sts.securityToken,
    bucket: sts.bucket,
    partSize: 10 * 1024 * 1024 // 分片大小 10MB，大文件自动分片
    // 如果开启传输加速，加上这一行
    // endpoint: 'oss-accelerate.aliyuncs.com'
  })

  // 生成文件名（UUID防止重名，和你之前逻辑一致）
  const uuid = crypto.randomUUID()
  const fileName = uuid + '_' + file.name

  try {
    // multipartUpload：小文件直接传，大文件自动分片、带进度
    const result = await client.multipartUpload(fileName, file, {
      progress: (p) => {
        percent.value = Math.floor(p * 100)
      }
    })
    // 拼接CDN访问地址
    fileUrl.value = `${sts.cdnDomain}/${fileName}`
    console.log('OSS上传结果', result)

    // ✅ 方案A：上传成功，调用后端save接口保存url入库
    await fetch('/upload/save', {
      method: 'POST',
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      body: "url="+fileUrl.value
    })
    alert("上传+保存成功")
  } catch (err) {
    console.error('上传失败！', err)
    alert("上传失败，看控制台报错："+err.message)
  }
}
</script>
